import apiClient from './api-client';
import { API_ENDPOINTS } from '../../constants/api.constants';
import { Book, BooksResponse, BooksQueryParams, CreateBookData, UpdateBookData } from '../../types';

export const booksService = {
  async getBooks(params?: BooksQueryParams): Promise<BooksResponse> {
    const response = await apiClient.get(API_ENDPOINTS.BOOKS, { params });
    return response.data.data;
  },

  async getBookById(id: string): Promise<Book> {
    const response = await apiClient.get(`${API_ENDPOINTS.BOOKS}/${id}`);
    return response.data.data;
  },

  async getDeletedBooks(): Promise<Book[]> {
    const response = await apiClient.get(API_ENDPOINTS.DELETED_BOOKS);
    return response.data.data;
  },

  async createBook(data: CreateBookData, coverImage?: File, bookFile?: File): Promise<Book> {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, String(value));
      }
    });

    if (coverImage) {
      formData.append('coverImage', coverImage);
    }

    if (bookFile) {
      formData.append('bookFile', bookFile);
    }

    const response = await apiClient.post(API_ENDPOINTS.BOOKS, formData);
    return response.data.data;
  },

  async updateBook(id: string, data: UpdateBookData, coverImage?: File, bookFile?: File): Promise<Book> {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, String(value));
      }
    });

    if (coverImage) {
      formData.append('coverImage', coverImage);
    }

    if (bookFile) {
      formData.append('bookFile', bookFile);
    }

    const response = await apiClient.patch(`${API_ENDPOINTS.BOOKS}/${id}`, formData);
    return response.data.data;
  },

  async deleteBook(id: string): Promise<Book> {
    const response = await apiClient.delete(`${API_ENDPOINTS.BOOKS}/${id}`);
    return response.data.data;
  },

  async hardDeleteBook(id: string): Promise<{ message: string }> {
    const response = await apiClient.delete(`${API_ENDPOINTS.BOOKS}/${id}/hard`);
    return response.data.data;
  },

  async restoreBook(id: string): Promise<Book> {
    const response = await apiClient.patch(`${API_ENDPOINTS.BOOKS}/${id}/restore`);
    return response.data.data;
  },

  async getReadUrl(id: string): Promise<{ url: string; expiresAt: string }> {
    const response = await apiClient.get(`${API_ENDPOINTS.BOOKS}/${id}/read`);
    return response.data.data;
  },

  async uploadCover(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(API_ENDPOINTS.UPLOAD_COVER, formData, {
      headers: {
        // Let browser set Content-Type automatically for FormData
      },
    });
    return response.data.data;
  },

  async uploadBookFile(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(API_ENDPOINTS.UPLOAD_FILE, formData, {
      headers: {
        // Let browser set Content-Type automatically for FormData
      },
    });
    return response.data.data;
  },
};
